import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-07-11'
        tag='Poshmark Snippets'
        title='Everything about Poshmark’s Offers to Likers'
      >
        <p>Master offers to likers in Poshmark to boost your sales!</p>​<h3>How to Send an Offer to Likers</h3>
        <ol>
          <li>Go to your listing that you wish to send an offer out on</li>
          <li>Select Offer / Price Drop</li>
          <li>Select Offer to Likers</li>
          <li>Enter Your Offer</li>
          <li>Select a Shipping Discount</li>
          <li>Hit Submit</li>
        </ol>
        ​<h3> What are the requirements for an offer to be recieved?</h3>
        <ul>
          <li>A seller discount must be included</li>
          <li>
            The offer must be at least 10% below the the lowest offer the potential buyer has received in the past 90
            days
          </li>
        </ul>
        ​<h3> Important Notes about Offers to Likers!</h3>
        <ul>
          <li>Counter offers by the potential buyer will not include a shipping discount</li>
          <li>Offers with no response or action expire after 24 hours</li>
          <li>
            Sellers cannot make a single item bundle with the same listing and send it to the potential buyer,
            regardless of discount offered
          </li>
          <li>
            Offers sent out go to all likers who have liked the listing as long as the offer is at least 10% below the
            lowest offer in the past 90 days
          </li>
          <li>Offers can be countered by the potential buyer</li>
        </ul>
        ​<p> Best of luck, and happy selling!</p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
